export var EnumGenderTypes;
(function (EnumGenderTypes) {
    EnumGenderTypes["M"] = "M";
    EnumGenderTypes["F"] = "F";
    EnumGenderTypes["U"] = "U";
    EnumGenderTypes["H"] = "H";
    EnumGenderTypes["S"] = "S";
    EnumGenderTypes["T"] = "T";
})(EnumGenderTypes || (EnumGenderTypes = {}));
